import * as React from 'react';
import { NavLink as ReactRouterNavLink, NavLinkProps } from 'react-router-dom';
import { Theme, withStyles, WithStyles, withTheme } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

type OwnProps = {
  to: string;
  label: string;
};

const styles = (theme: Theme) => ({
  navLink: {
    padding: theme.spacing(1, 2),
    margin: 'none',
    color: theme.palette.grey[600],
    textDecoration: 'none'
  }
});

type Props = WithStyles<typeof styles, true> & OwnProps & NavLinkProps;

const TabLinkComponent: React.FC<Props> = ({ classes, to, theme, label, ...props }) => (
  <ReactRouterNavLink
    exact
    className={classes.navLink}
    activeStyle={{
      borderBottom: '4px solid',
      borderBottomColor: theme.palette.primary.main,
      color: theme.palette.primary.main
    }}
    to={to}
    {...props}
  >
    <Typography variant="button" color="inherit">
      {label}
    </Typography>
  </ReactRouterNavLink>
);

export const TabLink = withStyles(styles)(withTheme(TabLinkComponent));
